import ModalBase from "../modals/ModalBase";
import { listSpecialEvents } from "../../js/theHub";
import EventCard from "./EventCard";

export default function SpecialEventsModal({ isOpen, onClose, session }) {
  const events = listSpecialEvents();
  const featured = events.filter((item) => item.featured);
  const rest = events.filter((item) => !item.featured);

  return (
    <ModalBase isOpen={isOpen} title="Special Events" onClose={onClose} wide>
      {events.length ? (
        <>
          {featured.length ? (
            <section className="the-hub-events">
              <h3>Featured Event</h3>
              <ul>
                {featured.map((item) => (
                  <EventCard key={item.id} item={item} session={session} />
                ))}
              </ul>
            </section>
          ) : null}
          {rest.length ? (
            <ul className="the-hub-events">
              {rest.map((item) => (
                <EventCard key={item.id} item={item} session={session} />
              ))}
            </ul>
          ) : null}
        </>
      ) : (
        <p>We have no custom events to share at this time.</p>
      )}
    </ModalBase>
  );
}
